// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"71ebfd1c","415":"11ef170f","453":"4fb1d1b8","511":"068fe5ca","835":"c9f0ab56"}[chunkId] + ".chunk.js";
};